import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
// import signiBackgroundImg from '../../assets/sign-up-background.png';
import signiBackgroundImg from '../../assets/conectogo_fundo.jpg';

export const Container = styled.div`
  height: 100%;  
  max-height: 100vh;

  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;

  width: 100%;
  max-width: 700px;
`;

const appearFronLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;

  animation: ${appearFronLeft} 1s;

  img {
    margin-bottom: 40px;
    max-width: 240px;
    max-height:150px;
  }

  form {
    margin: 5px 0;
    width: 340px;
    text-align: center;

    h1 {
      margin-bottom: 24px;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, '#f4ede8')};
      }
    }

  }

  > a {
    color:  var(--primary);
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;

    display: flex;
    align-items: center;
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${signiBackgroundImg}) no-repeat center;
  background-size: cover;
`;

export const ColInput = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin-top: 10px;

  b {
    color: var(--primary);
  }
`;

export const MessageFromApi = styled.div`
  margin-top: 10px;

  b {
    color:  var(--primary);
  }
`;
